// eslint-disable-next-line no-unused-vars
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {useGetUserQuery} from '../../api/main/auth';
import {setAuthLoading, setAuthUser, setLoggedOut} from './authSlice';
import {deleteCookie, getCookie} from '../../utils/helpers';
import {KEY_AUTHENTICATION_TOKEN} from '../../utils/constants/common';

function AuthFeature({children}) {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  const {data = undefined, isLoading} = useGetUserQuery(undefined, {
    skip: !getCookie(KEY_AUTHENTICATION_TOKEN),
  });

  useEffect(() => {
    const token = getCookie(KEY_AUTHENTICATION_TOKEN);
    if (!isLoading && token && !!data) {
      dispatch(
        setAuthUser({
          access_token: token,
          ...data,
        })
      );
    } else if (!isLoading) {
      deleteCookie(KEY_AUTHENTICATION_TOKEN);
      dispatch(setAuthLoading(false));
      dispatch(setLoggedOut(false));
    }
  }, [dispatch, data, isLoading]);

  useEffect(() => {
    const interval = setInterval(() => {
      const token = getCookie(KEY_AUTHENTICATION_TOKEN);
      if (!auth.loading && auth.token && auth.token !== token) {
        deleteCookie(KEY_AUTHENTICATION_TOKEN);
        dispatch(setLoggedOut(false));
      }
    }, 3000);
    return () => clearInterval(interval);
  }, [dispatch, auth]);

  return children({
    loading: isLoading || auth.loading,
    authenticated: auth.authenticated,
  });
}

AuthFeature.propTypes = {
  children: PropTypes.func.isRequired,
};

export default AuthFeature;
